(function () {
  function parseImages(card) {
    var jsonEl = card.querySelector('[data-pbs-images-json]');
    if (!jsonEl) return [];

    try {
      var data = JSON.parse(jsonEl.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function initCard(card) {
    var imageWrap = card.querySelector('[data-pbs-image-wrap]');
    var imageEls = card.querySelectorAll('[data-pbs-image-item]');
    var metaButtons = card.querySelectorAll('[data-pbs-meta-btn]');
    var images = parseImages(card);
    if (!metaButtons.length || !images.length) return;

    function setSelectedMeta(index) {
      var selected = images[index];
      if (!selected) return;

      imageEls.forEach(function (img, imgIndex) {
        var isShow = imgIndex === index;
        img.classList.toggle('pbs-show', isShow);
        img.classList.toggle('pbs-hide', !isShow);
      });

      if (imageWrap) {
        imageWrap.style.background = selected.bgColor || '#f5f3ee';
      }

      if (selected.tagBgColor) {
        card.style.setProperty('--pbs-accent', selected.tagBgColor);
        card.classList.add('has-meta-accent');
      } else {
        card.style.removeProperty('--pbs-accent');
        card.classList.remove('has-meta-accent');
      }

      metaButtons.forEach(function (button, buttonIndex) {
        var isActive = buttonIndex === index;
        button.classList.toggle('is-active', isActive);
        button.style.background = isActive && selected.tagBgColor ? selected.tagBgColor : '';
        button.style.color = isActive && selected.tagTextColor ? selected.tagTextColor : '';
      });
    }

    metaButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = Number(btn.getAttribute('data-pbs-meta-index'));
        if (Number.isNaN(index)) return;
        setSelectedMeta(index);
      });
    });

    // Always show first metaobject image/tag by default.
    setSelectedMeta(0);
  }

  document.querySelectorAll('.paws-product-card, .paws-product-card-v2').forEach(initCard);
})();
